import { ReducerAction, ReducerHandler } from '../../Types';
import { StoreError } from '../../Types/StoreTypes';
import { SET_ERROR, SET_ERROR_MESSAGE, SET_ERROR_REDIRECT_COUNTER, SET_ERROR_STATUS } from '../Actions/errorActions';

const initialState = {
    error: false,
    errorMessage: '',
    status: 0,
    errorRedirectCounter: parseInt(localStorage.getItem('errorRedirectCounter') || '0'),
} as StoreError;

const errorReducerMap: Record<string, ReducerHandler<StoreError>> = {
    [SET_ERROR]: (state, action) => ({ ...state, error: action.payload }),
    [SET_ERROR_MESSAGE]: (state, action) => ({ ...state, errorMessage: action.payload }),
    [SET_ERROR_STATUS]: (state, action) => ({ ...state, status: action.payload }),
    [SET_ERROR_REDIRECT_COUNTER]: (state, action) => ({ ...state, errorRedirectCounter: action.payload }),
};

function errorReducer(state = initialState, action: ReducerAction): StoreError {
    const handler = errorReducerMap[action.type];
    return handler ? handler(state, action) : state;
}

export default errorReducer;
